/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedRoleRequest
 */
export interface APIPatchedRoleRequest {
    /**
     * Guest user roles are roles that are reserved for the guest user type. They work like a normal organization user role, but won't be listed by the RoleViewSet.
     * @type {boolean}
     * @memberof APIPatchedRoleRequest
     */
    isGuestUserRole?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRoleRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRoleRequest
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIPatchedRoleRequest
     */
    permissions?: { [key: string]: any; };
}

/**
 * Check if a given object implements the APIPatchedRoleRequest interface.
 */
export function instanceOfAPIPatchedRoleRequest(value: object): value is APIPatchedRoleRequest {
    return true;
}

export function APIPatchedRoleRequestFromJSON(json: any): APIPatchedRoleRequest {
    return APIPatchedRoleRequestFromJSONTyped(json, false);
}

export function APIPatchedRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isGuestUserRole': json['is_guest_user_role'] == null ? undefined : json['is_guest_user_role'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
    };
}

export function APIPatchedRoleRequestToJSON(value?: APIPatchedRoleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'is_guest_user_role': value['isGuestUserRole'],
        'name': value['name'],
        'description': value['description'],
        'permissions': value['permissions'],
    };
}

